import React from 'react';
import { Card, Badge } from 'nelitomorphism';
import './Skills.css';

const GROUPS = [
  {
    label: 'Languages',
    items: ['JavaScript', 'TypeScript', 'PHP', 'HTML', 'CSS'],
  },
  {
    label: 'Frontend',
    items: ['React.js', 'Next.js', 'Vue.js', 'Tailwind CSS', 'jQuery', 'Hugo'],
  },
  {
    label: 'Backend',
    items: ['Node.js', 'Nest.js', 'Laravel', 'Rest API', 'MySQL', 'PostgreSQL'],
  },
  {
    label: 'Infrastructure',
    items: ['AWS', 'Lambda', 'Docker', 'Linux', 'CI/CD', 'GitHub Actions'],
  },
  {
    label: 'Practices',
    items: ['TDD', 'OOP', 'Scrum', 'Testing', 'No-code / Low-code'],
  },
];

const LANGUAGES = [
  { label: 'Portuguese', level: 'Native' },
  { label: 'English', level: 'Fluent' },
];

const Skills = () => (
  <section id="skills">
    <Card title="Stack" meta="tools & practices">
      <div className="skills-grid">
        {GROUPS.map(g => (
          <div key={g.label} className="skills-group">
            <span className="skills-label">{g.label}</span>
            <div className="skills-items">
              {g.items.map(i => (
                <Badge key={i}>{i}</Badge>
              ))}
            </div>
          </div>
        ))}
        <div className="skills-group">
          <span className="skills-label">Languages</span>
          <div className="skills-items">
            {LANGUAGES.map(l => (
              <Badge key={l.label} tone="accent2">
                {l.label} · {l.level}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </Card>
  </section>
);

export default Skills;
